import styled from 'styled-components';

import { white } from 'variables/colors';
import { borderRadius, boxShadow, boxShadowHeavy } from 'variables/general';

export const Card = styled.div`
  padding: 1.5em;
  background-color: ${white};
  border-radius: ${borderRadius};
  box-shadow: ${boxShadow};
`;

export const CardHeavyShadow = styled.div`
  padding: 1.5em;
  background-color: ${white};
  border-radius: ${borderRadius};
  box-shadow: ${boxShadowHeavy};
`;
